import './WorkedWith.css';
import { useEffect, useState } from 'react';
import { getWorkedWith } from '../services/data';

export default function WorkedWith() {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchWorkedWith = async () => {
      try {
        const result = await getWorkedWith();
        setCompanies(result);
      } catch (error) {
        console.log('Error fetching worked with:', error);
      }
    };
    fetchWorkedWith();
  }, []);

  if (companies.length === 0) return null;

  // Double the list for seamless loop
  const marqueeItems = [...companies, ...companies];

  return (
    <div className='worked-with-section' id='worked-with'>
      <div className='worked-with-header'>
        <h2 className='worked-with-title'>Professional Collaborations</h2>
        <div className='title-underline'></div>
      </div>
      
      <div className='marquee-container'>
        <div className='marquee-track'>
          {marqueeItems.map((company, index) => (
            <div className='logo-tile' key={index}>
              <div className='logo-box'>
                <img
                  src={company.logo}
                  alt={company.name || 'Company'}
                  className='marquee-logo'
                  loading="lazy"
                />
              </div>
              <span className='logo-label'>{company.name}</span>
            </div>
          ))}
        </div>
        <div className="marquee-fade-left"></div>
        <div className="marquee-fade-right"></div>
      </div>
    </div>
  );
}
